<h1 mat-dialog-title style="color: #F7671E; font-weight: 900; font-size: 2rem;">Grand jeu d'Halloween</h1>
<div mat-dialog-content>
  <div style="display: flex; flex-wrap: wrap;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
    <div style="flex: 3;">
      <div>
        <h3 style="font-weight: bold;">Halloween traverse les rues de Levallois !</h3>
        <p>
          La Ville de Levallois soutient l’Association des Commerçants et Artisans de Levallois qui organise, samedi 30 octobre de 9h à 14h une journée déguisée à la recherche des citrouilles, qui s’affichent sur les vitrines des commerçants.
        </p>
        <br />

        <h3 style="font-weight: bold;">Jouez et gagnez !</h3>
        <p>
          Pour cette occasion, en plus des incontournables bonbons et friandises à récolter, de nombreux lots seront à remporter notamment grâce à la participation des enseignes participantes.
        </p>
        <br />
      </div>
      
      <div style="flex: 2; display: flex; justify-content: space-evenly; margin: 1rem 0;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
        <a mat-stroked-button href="assets/halloween-presentation.pdf" target="_blank" style="margin: 1rem;"><mat-icon style="margin-right: 1rem; color: #F7671E;">cloud_download</mat-icon> Présentation du jeu</a>
        <a mat-stroked-button href="assets/halloween-reglement.pdf" target="_blank" style="margin: 1rem;"><mat-icon style="margin-right: 1rem; color: #F7671E;">cloud_download</mat-icon> Règlement du jeu</a>
      </div>
    </div>
    <div style="flex: 1; padding: 10px;">
     <img src="assets/halloween-affiche.jpg" style="max-width: 100%;" />
    </div>
  </div>
</div>